import { useState } from "react"
import { Outlet } from "react-router-dom"
// material
import { styled, useTheme } from "@mui/material/styles"
// hooks
import useCollapseDrawer from "../../hooks/useCollapseDrawer"
//
import CircularIndeterminate from "../../components/CircularIndeterminate"
import DashboardNavbar from "./DashboardNavbar"
import DashboardSidebar from "./DashboardSidebar"

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 50
const APP_BAR_DESKTOP = 92

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden"
})

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: "20px",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}))

// ----------------------------------------------------------------------

export default function MainLayout() {
  const theme = useTheme()
  const { collapseClick } = useCollapseDrawer()
  const [open, setOpen] = useState(false)

  return (
    <RootStyle className="h-full">
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      <CircularIndeterminate />
      <MainStyle
        sx={{
          transition: theme.transitions.create("margin", {
            duration: theme.transitions.duration.complex
          }),
          ...(collapseClick && {
            ml: "102px"
          })
        }}
      >
        <Outlet />
      </MainStyle>
    </RootStyle>
  )
}
